import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { Card, CardBody, Col, } from 'reactstrap';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import SmallLoader from '../../../shared/components/SmallLoader';
import OrderTableHead from './OrderTableHead';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
  },
  paper: {
    marginTop: theme.spacing(5),
    width: '100%',
    height: 550,
    overflowX: 'auto',
    overflowY: 'auto',
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 650,
  },
  tableProductCell: {
    minWidth: 500,
  },
}));


const getSorting = (order, orderBy) => {
  if (order === 'desc') {
    return (a, b) => {
      if (a[orderBy] < b[orderBy]) {
        return -1;
      }
      if (a[orderBy] > b[orderBy]) {
        return 1;
      }
      return 0;
    };
  }
  return (a, b) => {
    if (a[orderBy] > b[orderBy]) {
      return -1;
    }
    if (a[orderBy] < b[orderBy]) {
      return 1;
    }
    return 0;
  };
};

const OrderTable = ({ data, pageInfo, callback, isTableLoading }) => {
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('calories');
  const [selected, setSelected] = useState(new Map([]));
  const [page, setPage] = useState(pageInfo?.pageNo);
  const [rowsPerPage, setRowsPerPage] = useState(pageInfo?.pageSize);

  const handleRequestSort = (event, property) => {
    const orderByTemp = property;
    let orderTemp = 'desc';
    if (orderBy === property && order === 'desc') { orderTemp = 'asc'; }
    setOrder(orderTemp);
    setOrderBy(orderByTemp);
  };

  const handleSelectAllClick = (event, checked) => {
    if (checked) {
      const newSelected = new Map();
      data.map(n => newSelected.set(n.id, true));
      setSelected(newSelected);
      return;
    }
    setSelected(new Map([]));
  };

  const handleClick = (event, id) => {
    const newSelected = new Map(selected);
    const value = newSelected.get(id);
    let isActive = true;
    if (value) {
      isActive = false;
    }
    newSelected.set(id, isActive);
    setSelected(newSelected);
  };

  const handleChangePage = (event, item) => {
    callback({ opage: item + 1, opageSize: rowsPerPage });
    setPage(item);
  };

  const handleChangeRowsPerPage = (event) => {
    callback({ opage: page + 1, opageSize: Number(event.target.value) });
    setRowsPerPage(Number(event.target.value));
  };

  const isSelected = id => !!selected.get(id);
  const emptyRows = rowsPerPage - Math.min(rowsPerPage, pageInfo.totalElements - (page * rowsPerPage));
  const classes = useStyles();
  return (
    <Col md={12} lg={12}>
      <Card>
        <CardBody>
          <div className={classes.root}>
            <Paper className={classes.paper}>
              {/* <TableContainer style={{ maxHeight: 550, minHeight:150, marginTop:10 }}> */}
              <Table stickyHeader className={classes.table} size="small">
                <OrderTableHead
                  numSelected={[...selected].filter(el => el[1]).length}
                  order={order}
                  orderBy={orderBy}
                  onSelectAllClick={handleSelectAllClick}
                  onRequestSort={handleRequestSort}
                  rowCount={data.length}
                />
                {isTableLoading ? <TableBody>
                  <TableRow>
                    <TableCell colSpan={9} height="150"
                      className="MuiTableCell-alignCenter"
                      align="center">
                      <SmallLoader loading={isTableLoading} />
                    </TableCell>
                  </TableRow>
                </TableBody>
                  : <TableBody>
                    {data?.length ? data
                      .sort(getSorting(order, orderBy))
                      .map((d) => {
                        const select = isSelected(d.id);
                        return (
                          <TableRow key={`${d.amazonOrderId}-${d.sku}`}
                            className="material-table__row"
                          >
                            <TableCell
                              className="MuiTableCell"
                              width="8%"
                            >
                              {d.amazonOrderId}
                            </TableCell>
                            <TableCell
                              className="MuiTableCell"
                              width="10%"
                            >{d.buyerName}
                            </TableCell>
                            <TableCell
                              className="MuiTableCell"
                              width="7%"
                            >{d.sku}
                            </TableCell>
                            <TableCell
                              className={classes.tableProductCell}
                              width="500"
                            >{d.productName}
                            </TableCell>
                            <TableCell
                              className="MuiTableCell-alignRight"
                              align="right"
                              width="8%"
                            //  style={{ maxWidth: 50 }} 
                            >{d.quantityShipped}
                            </TableCell>
                            <TableCell
                              className="MuiTableCell-alignRight"
                              align="right"
                              width="7%"
                            // style={{ maxWidth: 60 }} 
                            >$ {d.itemPrice}
                            </TableCell>
                            <TableCell
                              className="MuiTableCell"
                              // style={{ maxWidth: 50 }} 
                              width="7%"
                            >{d.currency}
                            </TableCell>
                            <TableCell
                              className="MuiTableCell"
                              // style={{ maxWidth: 60 }} 
                              width="10%"
                            >{d.carrier}
                            </TableCell>
                            <TableCell
                              className="MuiTableCell"
                              // style={{ maxWidth: 100 }} 
                              width="10%"
                            >{d.trackingNumber}
                            </TableCell>
                            <TableCell
                              className="MuiTableCell"
                              // style={{ maxWidth: 85 }} 
                              width="7%"
                            >{d.salesChannel}
                            </TableCell>
                            <TableCell
                              className="MuiTableCell"
                              //  style={{ maxWidth: 60 }} 
                              width="6%"
                            >{d.purchaseDate}
                            </TableCell>
                            <TableCell
                              className="MuiTableCell"
                              width="5%"
                            //  style={{ maxWidth: 60 }} 
                            >{d.shipmentDate}
                            </TableCell>
                          </TableRow>
                        );
                      }) : <TableRow>
                      <TableCell colSpan={12}>No data to display</TableCell>
                    </TableRow>}
                    {/* {emptyRows > 0 && (
                 <TableRow>
                 <TableCell colSpan={12}>No data to display</TableCell>   
               </TableRow>
                )} */}
                  </TableBody>}
              </Table>
              {/* </TableContainer> */}
            </Paper>
          </div>
          <TablePagination
            component="div"
            className="material-table__pagination"
            count={pageInfo.totalElements}
            rowsPerPage={rowsPerPage}
            page={page}
            backIconButtonProps={{ 'aria-label': 'Previous Page' }}
            nextIconButtonProps={{ 'aria-label': 'Next Page' }}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
            rowsPerPageOptions={[250, 500, 1000, 1500]}
            dir="ltr"
            SelectProps={{
              inputProps: { 'aria-label': 'rows per page' },
              native: true,
            }}
          />
        </CardBody>
      </Card>
    </Col>
  );
};

OrderTable.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  pageInfo: PropTypes.object.isRequired,
  callback: PropTypes.func.isRequired,
  isTableLoading: PropTypes.bool.isRequired,
}

export default OrderTable;
